import {connect} from 'react-redux';
import MobileApp from '../../components/MobileApp';

export const mapStateToProps = state => ({
  url: state.template.url,
  showInfoPopUp: state.info.show
});

export default connect(mapStateToProps)(MobileApp);
